// @flow

export const HEIGHT: number = 54;
export const PANEL_DX: number = 12;
export const PANEL_DY: number = 12;
